<template>
  <router-view />
</template>
<script>
export default {
  name: "App"
};
</script>
<style>
@import "../../assets/css/fonts.css";
@import "../../assets/css/bootstrap-custom.css";
html {
  width: 100%;
  height: 100%;
}
body {
  width: 100%;
  height: 100%;
  font-family: "Yekan";
  margin: 0;
  overflow-x: hidden;
  direction: rtl;
  background-color: #ebeff2;
  text-align: right;
}
a,
a:hover {
  text-decoration: none;
}
ul,
li {
  margin: 0;
  padding: 0;
}
.dir-ltr {
  direction: ltr;
}
</style>
